export class SponsorCodeModel {
	uuid: string
	merchantId: string
	id: number
	code: string
	description: string
	bookable: boolean
	bookableChangedAt: string
	priorSale: boolean
	releaseDays: number
	releaseTime: string
}



// WEBPACK FOOTER //
// ./src/app/models/sponsor-code.model.ts